export default "__VITE_ASSET__LKnOUAwndhao8Kp5JA7cbg__"